export const APP_DETAILS = {
  FA_NAME: 'فیلیمو مدرسه',
  EN_NAME: 'Filimo School',
  AR_NAME: 'فیلیمو مدرسه',
  TJ_NAME: 'Filimo School',
  FA_DESCRIPTION: 'فیلیمو مدرسه تی وی',
  EN_DESCRIPTION: 'Filimo School TV',
  AR_DESCRIPTION: 'فیلیمو مدرسه تی وی',
  TJ_DESCRIPTION: 'Filimo School телевизион',
};

export const APP_API = {
  PROXY_URL: 'https://www.filimo.school',
  API_PROTOCOL: 'https',
  API_SUBDOMAIN: 'www',
  API_BASE: 'filimo.school',
  API_PATH: 'api',
  API_VERSION: 'v1',
};

export const APP_GLOBAL_CONFIG = {
  APP_VERSION: '1.2.0',
  ROWS_PER_PAGE: 5,
  GOOGLE_TAG_MANAGER: 'GTM-T3K7P8F',
  LOGIN_URL: 'https://filimo.school/activate',
  APPS_URL: 'https://filimo.school/app',
};
